import React from 'react';
import { connect } from 'react-redux';
import LeftDebugChatPanel from '../LeftDebugChatPanel/LeftDebugChatPanel';
import OutsideClickPanel from '../../../components/OutsideClickPanel/OutsideClickPanel';
import ToasterService from '../../../../services/ToasterService';
import menuItems from '../../../../const/menuItems';
import * as actions from '../../../../redux/projects/actions.projects';
import TextFieldWithJsonWrapper from '../../../components/TextFieldWithJsonWrapper/TextFieldWithJsonWrapper';
import JsonPanelBody from '../JsonPanel/JsonPanelBody';
import PopupButtons from '../../../components/Popup/PopupButtons';
import PopupCancelButton from '../../../components/Popup/PopupCancelButton';
import PopupButton from '../../../components/Popup/PopupButton';
import JsonPanelHeader from '../JsonPanel/JsonPanelHeader';
import JsonPanel from '../JsonPanel/JsonPanel';
import { smartJSONParse } from '../../../../services/mini/isValidJSON';

class AuthDataPanel extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            opened: false,
            authData: this.props.authData || null,
            authDataValid: true
        };
    }

    onKeyCb = (e) => {
        const { opened } = this.state;
        if (e.keyCode === 27 && opened) {
            this.closePanel();
        }
    }

    componentDidMount() {
        document.addEventListener('keydown', this.onKeyCb, false);
    }

    componentDidUpdate(prevProps) {
        const { authData, authDataPanelOpened } = this.props;

        if (authData !== prevProps.authData || authDataPanelOpened !== prevProps.authDataPanelOpened) {
            this.updateAuthData(authData || '', authDataPanelOpened);
        }
    }

    componentWillUnmount() {
        document.removeEventListener('keydown', this.onKeyCb, false);
    }

    updateAuthData = (authData, authDataPanelOpened) => {
        this.setState({
            authData: !authData ? '' : JSON.stringify(authData, null, 4),
            opened: authDataPanelOpened
        });
    }

    onChange = (authData) => {
        this.setState({ authData });
    }

    onValidate = (authDataValid) => {
        this.setState({ authDataValid });
    }

    closePanel = () => {
        this.setState({ opened: false, authDataValid: true });
        this.props.hideAuthDataPanel();
    }

    saveAuthData = () => {
        const { authData, authDataValid } = this.state;
        const { project, environment, saveAuthData } = this.props;
        const successToasterMessage = 'Auth data successfully applied';

        if (!authDataValid) {
            return;
        }

        const authDataObj = authData === '' ? {} : smartJSONParse(authData);

        saveAuthData({ authData: authDataObj, project, environment });

        ToasterService.showInfo({ title: successToasterMessage });

        this.closePanel();
    }

    handleClickOutside = (e) => {
        const { opened } = this.state;
        const curEl = e.target;
        const exitElements = [
            '.main-header',
            '.debugging-chat_top-btns',
            '.left-debug-chat-panel'
        ];
        let shouldClosePanel = false;
        for (let i = 0; i < exitElements.length; i++) {
            if (curEl.closest(exitElements[i])) {
                shouldClosePanel = true;
                break;
            }
        }

        if (opened && shouldClosePanel) {
            this.closePanel();
        }
    }

    render() {
        const { opened, authData, authDataValid } = this.state;
        const disableApplyBtn = authData === null || !authDataValid;

        return (
            <LeftDebugChatPanel opened={opened}>
                <OutsideClickPanel
                    onOutsideClick={this.handleClickOutside}
                    opened={opened}
                    classes="outside-click-panel auth-data-panel-overlay">
                    <JsonPanel className="auth-data-panel">
                        <JsonPanelHeader
                            title="Auth Data"
                            docUrl={`${menuItems.docs.href}/server-api/api/api-reference#oncreate`} />
                        <JsonPanelBody>
                            {opened && <TextFieldWithJsonWrapper
                                value={authData}
                                placeholder="Enter auth data (JSON object or string)"
                                onChange={this.onChange}
                                onShiftEnter={this.saveAuthData}
                                onValidate={this.onValidate} />}
                        </JsonPanelBody>
                        <PopupButtons>
                            <PopupCancelButton action={this.closePanel} />
                            <PopupButton label="Apply" action={this.saveAuthData} className={disableApplyBtn && 'disabled'} />
                        </PopupButtons>
                    </JsonPanel>
                </OutsideClickPanel>
            </LeftDebugChatPanel>
        );
    }
}


function mapStateToProps({ projectsInfo }, ownProps) {
    return {
        authData: projectsInfo.currentProject.authData,
        authDataPanelOpened: projectsInfo.currentProject.authDataPanelOpened,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        saveAuthData: (param) => dispatch(actions.saveAuthData(param)),
        hideAuthDataPanel: (param) => dispatch(actions.hideAuthDataPanel(param)),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(AuthDataPanel);
